import { type NeaWishlist, NeaWishlistRemoveResponse } from "@expert/types";


export const fetchCurrentWishList = async () => {
	const { data: wishlist } = await useFetch('/api/wishlist', {
		key: 'currentWishList',
	});
	useWishListItemCount().value = wishlist?.response?._data?.entries?.length || wishlist?.value?.entries?.length;
	return wishlist;
};

const mergeWishlist = async () => {
	const systemUserId = `systemuser_${useCurrentUserState()?.value?.userId}`;
	const cookieUserId = useExpCookieIdentifier().value;

	const { data: systemUserWishlist } = await useFetch('/api/wishlist', {
	});

	if (systemUserWishlist.value && Array.isArray(systemUserWishlist.value?.entries)) {
		const { data: wishlist } = await useFetch('/api/wishlist/merge', {
			method: 'POST',
			body: {
				systemUserId: systemUserId,
			},
		});

		return wishlist.value;
	}

	const { data: cookieUserWishlist } = await useFetch('/api/wishlist', {
	});

	if (cookieUserWishlist.value && Array.isArray(cookieUserWishlist.value?.entries)) {
		for (const article of cookieUserWishlist.value?.entries) {
			await addArticleToWishList(useCurrentStore().value?.id, article.articleId, true);
		}
	}
}

export const getWishlist = async () => {
	const hasSystemUser: boolean = !useCurrentUserState()?.value?.roles?.includes('ANONYMOUS');

	let wishlist;
	if (hasSystemUser) {
		wishlist = await mergeWishlist();
	}

	if (!wishlist) {
		wishlist = await fetchCurrentWishList();
	}

	return wishlist;
};

const addArticleToWishList = async (storeId: string, articleId: string, registered: boolean) => {
	const logger = useLogger('composables/expWishList');
	let wishlist: NeaWishlist;
	try {
		wishlist = await $fetch<NeaWishlist>('/api/wishlist/addArticle', {
			query: {
				storeId: storeId,
				articleId: articleId,
				registered: registered,
			},
		});
	} catch (err) {
		logger.warn('Error while trying to add article to wishlist', err);
		wishlist = {
			id: '',
			userId: '',
			storeId: storeId,
			entries: [],
			registered: true,
		};
	}

	useWishListItemCount().value = wishlist.entries.length;
	useCurrentWishList().value = wishlist;

	await useGeneralTrick({
		eventType: 'ADD_TO_CART_ITEM',
		sessionId: useCurrentSessionIdentifier()?.value,
		json: {
			cartType: 'WISHLIST_CART',
			articleId: articleId,
			cartId: useExpCookieIdentifier()?.value,
			quantity: 1,
		},
	});
};

const deleteArticleFromWishList = async (articleId: string) => {
	const logger = useLogger('composables/expWishList');
	try {
		const removeResponse = await $fetch<NeaWishlistRemoveResponse>('/api/wishlist/removeArticle', {
			query: {
				articleId: articleId,
			},
		});

		if (removeResponse === NeaWishlistRemoveResponse.REMOVED) {
			if (useWishListItemCount().value > 0) {
				useWishListItemCount().value -= 1;
			}
			const currentWishlist = structuredClone(useCurrentWishList().value);
			currentWishlist.entries = currentWishlist.entries.filter((wItem) => wItem.articleId !== articleId);
			currentWishlist.registered = false;
			useCurrentWishList().value = currentWishlist;

			await useGeneralTrick({
				eventType: 'ADD_TO_CART_ITEM',
				sessionId: useCurrentSessionIdentifier()?.value,
				json: {
					cartType: 'WISHLIST_CART',
					articleId: articleId,
					cartId: useExpCookieIdentifier()?.value,
					quantity: 0,
				},
			});
		}
	} catch (error) {
		logger.warn(`Error while trying to remove article (${articleId}) from wishlist`, error);
	}
}

export const updateStoreForWishList = (storeId: string) => {
	return useFetch('/api/wishlist/changeStore', {
		key: 'deleteArticleFromWishList' + useExpCookieIdentifier()?.value,
		query: {
			storeId: storeId,
		},
	});
};

export const addToWishList = (articleId: string) => {
	let storeId = useCurrentStore().value?.id;
	if (useCurrentWishList()?.value?.entries?.find((wItem) => wItem.articleId == articleId)) {
		deleteArticleFromWishList(articleId);
	} else {
		document.getElementById(articleId + '-addingWishList');
		addArticleToWishList(storeId, articleId, true);
	}
}
